window.addEventListener('load', () => {
  const body = document.querySelector('body');
  const ventesItem = document.querySelectorAll('.bien-item');
  const modal = document.querySelector('#modal');

  ventesItem.forEach((item) => {
    item.addEventListener('click', () => {
      modal.querySelector('.title').textContent =
        item.getAttribute('data-title');

      modal.querySelector('.content-style').innerHTML = item?.querySelector(
        '.description-detaillee'
      ).innerHTML;

      modal.querySelector('.wpcf7-hidden[name="avis-de-recherche-id"]').value =
        item.getAttribute('data-id');

      modal.querySelector(
        '.wpcf7-hidden[name="avis-de-recherche-title"]'
      ).value = item.getAttribute('data-title');

      const existingImg = modal.querySelector(
        '.avis-de-recherche__details img'
      );
      if (existingImg) {
        existingImg.remove();
      }

      modal
        .querySelector('.avis-de-recherche__details')
        .appendChild(item.querySelector('img').cloneNode(true));

      modal.setAttribute('data-visible', 'true');

      // Disable body scrolling
      body.classList.add('no-scroll');
    });
  });

  document.querySelector('.modal__close').addEventListener('click', () => {
    modal.setAttribute('data-visible', '');

    // Enable body scrolling
    body.classList.remove('no-scroll');
  });
});
